import { Navigate, Outlet, useLocation } from 'react-router';

import { isApiError } from '@/api/client';
import { ErrorState } from '@/components/PageHeader';
import { SessionProvider, useMeQuery } from '@/features/auth/session';

/** Wraps every authenticated route: resolves /auth/me once, redirects to sign-in on 401. */
export function AuthGuard() {
  const me = useMeQuery();
  const location = useLocation();

  if (me.isPending) {
    return (
      <div className="flex h-dvh items-center justify-center text-ink3" role="status">
        Loading…
      </div>
    );
  }
  if (me.isError) {
    if (isApiError(me.error) && (me.error.status === 401 || me.error.code === 'UNAUTHENTICATED')) {
      const from = `${location.pathname}${location.search}`;
      return (
        <Navigate
          to={`/sign-in${from !== '/' ? `?from=${encodeURIComponent(from)}` : ''}`}
          replace
        />
      );
    }
    return (
      <div className="p-6">
        <ErrorState error={me.error} onRetry={() => void me.refetch()} />
      </div>
    );
  }
  return (
    <SessionProvider value={me.data}>
      <Outlet />
    </SessionProvider>
  );
}

/** Foremen on web only see their own history (doc 11). */
export function OfficeOnly() {
  const me = useMeQuery();
  if (me.data && me.data.user.role === 'foreman') return <Navigate to="/history" replace />;
  return <Outlet />;
}
